var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement"},[(_vm.type=='agr')?_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.ruleCotent&&_vm.ruleCotent.content))]):(_vm.type=='pri')?_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.ruleCotent&&_vm.ruleCotent.privacy))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4602a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement.vue
// module id = null
// module chunks = 